import { LoanAmountsData } from 'app/models/loan-params'

/**
 * Returns the latest LoanAmountsData entry whose effectiveDate is on or before
 * the given date string (YYYY-MM-DD). Returns null when no eligible entry exists.
 *
 * Dates are compared as strings (YYYY-MM-DD lexicographic) to avoid timezone
 * round-trip bugs. Same-day entries are ordered by processedTime so the entry
 * processed last wins — mirroring how the ledger orders the amounts history.
 */
export const loanAmountsEntryAsOf = (
  entries: LoanAmountsData[],
  date: string,
): LoanAmountsData | null => {
  const eligible = entries
    .filter((e) => e.effectiveDate <= date)
    .sort(
      (a, b) =>
        a.effectiveDate.localeCompare(b.effectiveDate) ||
        a.processedTime.localeCompare(b.processedTime),
    )
  return eligible[eligible.length - 1] ?? null
}
